export interface ArticleSection {
  heading: { pt: string; de: string; en: string };
  body: { pt: string; de: string; en: string };
}

export interface ArticleData {
  slug: string;
  icon: string;
  title: { pt: string; de: string; en: string };
  excerpt: { pt: string; de: string; en: string };
  sections: ArticleSection[];
}

export const articles: ArticleData[] = [
  {
    slug: 'cssbuy-review',
    icon: 'ri-star-line',
    title: {
      pt: 'CSSBuy Review 2026: O CSSBuy é Legítimo e Seguro?',
      de: 'CSSBuy Review 2026: Ist CSSBuy seriös und sicher?',
      en: 'CSSBuy Review 2026: Is CSSBuy Legit and Safe?',
    },
    excerpt: {
      pt: 'Uma análise independente do CSSBuy: como funciona o agente de compras, prós e contras, e o que observar antes de usar a plataforma.',
      de: 'Eine unabhängige Analyse von CSSBuy: Wie der Einkaufsagent funktioniert, Vor- und Nachteile und worauf Sie vor der Nutzung achten sollten.',
      en: 'An independent analysis of CSSBuy: how the buying agent works, pros and cons, and what to watch before using the platform.',
    },
    sections: [
      {
        heading: {
          pt: 'Como o CSSBuy funciona',
          de: 'Wie CSSBuy funktioniert',
          en: 'How CSSBuy works',
        },
        body: {
          pt: 'O CSSBuy atua como um agente de compras intermediário. Você encontra um produto, envia o link para a plataforma, e o agente compra, recebe no armazém e envia para você. O processo centraliza pesquisa, armazenamento e envio em um só lugar.',
          de: 'CSSBuy fungiert als zwischengeschalteter Einkaufsagent. Sie finden ein Produkt, senden den Link an die Plattform, und der Agent kauft es, lagert es ein und versendet es an Sie. Der Prozess bündelt Recherche, Lagerung und Versand an einem Ort.',
          en: 'CSSBuy acts as an intermediary buying agent. You find a product, submit the link to the platform, and the agent purchases it, receives it at the warehouse and ships it to you. The process centralizes research, storage and shipping in one place.',
        },
      },
      {
        heading: {
          pt: 'Pontos positivos e negativos',
          de: 'Vor- und Nachteile',
          en: 'Pros and cons',
        },
        body: {
          pt: 'Entre os pontos positivos estão a centralização de pedidos e fotos de QC. Como desvantagem, os custos de shipping e taxas variam conforme o país e devem ser sempre confirmados antes de fechar a compra.',
          de: 'Zu den Vorteilen gehören die Bündelung von Bestellungen und QC-Fotos. Als Nachteil variieren Versandkosten und Gebühren je nach Land und sollten vor dem Kauf immer bestätigt werden.',
          en: 'Among the positives are centralized orders and QC photos. As a downside, shipping costs and fees vary by country and should always be confirmed before completing a purchase.',
        },
      },
      {
        heading: {
          pt: 'O que observar antes de usar',
          de: 'Worauf Sie vor der Nutzung achten sollten',
          en: 'What to watch before using',
        },
        body: {
          pt: 'Verifique sempre a URL oficial, proteja sua conta com senha forte e confirme preços e prazos. Este guia é independente e não substitui a verificação nos canais oficiais.',
          de: 'Prüfen Sie immer die offizielle URL, schützen Sie Ihr Konto mit einem starken Passwort und bestätigen Sie Preise und Fristen. Dieser Guide ist unabhängig und ersetzt nicht die Prüfung über offizielle Kanäle.',
          en: 'Always verify the official URL, protect your account with a strong password and confirm prices and timelines. This guide is independent and does not replace verification through official channels.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-shipping-cost',
    icon: 'ri-truck-line',
    title: {
      pt: 'CSSBuy Shipping Cost: Guia Completo de Custos de Envio',
      de: 'CSSBuy Shipping Cost: Kompletter Guide zu Versandkosten',
      en: 'CSSBuy Shipping Cost: Complete Shipping Cost Guide',
    },
    excerpt: {
      pt: 'Entenda os fatores que influenciam o custo de envio do CSSBuy e como calcular o valor total antes de finalizar sua compra.',
      de: 'Verstehen Sie die Faktoren, die die Versandkosten bei CSSBuy beeinflussen, und wie Sie den Gesamtbetrag vor dem Kauf berechnen.',
      en: 'Understand the factors that influence CSSBuy shipping costs and how to calculate the total before completing your purchase.',
    },
    sections: [
      {
        heading: {
          pt: 'Fatores que afetam o custo',
          de: 'Faktoren, die die Kosten beeinflussen',
          en: 'Factors that affect cost',
        },
        body: {
          pt: 'O custo depende do país de destino, peso, dimensões e método de envio escolhido. Serviços extras como seguro e embalagem reforçada também aumentam o valor final.',
          de: 'Die Kosten hängen von Zielland, Gewicht, Abmessungen und gewählter Versandmethode ab. Zusatzdienste wie Versicherung und verstärkte Verpackung erhöhen den Endbetrag ebenfalls.',
          en: 'The cost depends on destination country, weight, dimensions and chosen shipping method. Extra services like insurance and reinforced packaging also raise the final amount.',
        },
      },
      {
        heading: {
          pt: 'Como estimar o total',
          de: 'So schätzen Sie die Gesamtkosten',
          en: 'How to estimate the total',
        },
        body: {
          pt: 'Some o valor do produto, taxas do agente, frete e possíveis impostos de importação. Usar o spreadsheet para comparar cenários ajuda a escolher a opção mais econômica.',
          de: 'Addieren Sie Produktpreis, Agentengebühren, Versand und mögliche Einfuhrsteuern. Das Spreadsheet zum Vergleichen von Szenarien hilft, die günstigste Option zu wählen.',
          en: 'Add the product price, agent fees, shipping and possible import taxes. Using the spreadsheet to compare scenarios helps choose the most economical option.',
        },
      },
      {
        heading: {
          pt: 'Envio por país',
          de: 'Versand nach Land',
          en: 'Shipping by country',
        },
        body: {
          pt: 'Brasil, Alemanha, EUA e Reino Unido têm linhas e custos diferentes. Confirme sempre as opções mais recentes para o seu destino antes de comprar.',
          de: 'Brasilien, Deutschland, USA und Großbritannien haben unterschiedliche Linien und Kosten. Bestätigen Sie immer die aktuellsten Optionen für Ihr Ziel vor dem Kauf.',
          en: 'Brazil, Germany, the USA and the UK have different lines and costs. Always confirm the latest options for your destination before purchasing.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-coupon',
    icon: 'ri-coupon-line',
    title: {
      pt: 'CSSBuy Coupon e Discount Code: Guia de Descontos',
      de: 'CSSBuy Coupon und Discount Code: Rabatt-Guide',
      en: 'CSSBuy Coupon and Discount Code: Discount Guide',
    },
    excerpt: {
      pt: 'Saiba como funcionam os cupons e códigos de desconto do CSSBuy, o que verificar antes de usar e como evitar ofertas falsas.',
      de: 'Erfahren Sie, wie CSSBuy-Coupons und Rabattcodes funktionieren, was Sie vor der Nutzung prüfen sollten und wie Sie falsche Angebote vermeiden.',
      en: 'Learn how CSSBuy coupons and discount codes work, what to check before using them and how to avoid fake offers.',
    },
    sections: [
      {
        heading: {
          pt: 'Como funcionam os cupons',
          de: 'Wie Coupons funktionieren',
          en: 'How coupons work',
        },
        body: {
          pt: 'Cupons e códigos de desconto costumam ser oferecidos em campanhas e podem ter condições específicas, como valor mínimo de compra ou validade limitada.',
          de: 'Coupons und Rabattcodes werden oft in Kampagnen angeboten und können Bedingungen wie Mindestbestellwert oder begrenzte Gültigkeit haben.',
          en: 'Coupons and discount codes are often offered in campaigns and may have conditions like minimum order value or limited validity.',
        },
      },
      {
        heading: {
          pt: 'Verifique antes de usar',
          de: 'Vor der Nutzung prüfen',
          en: 'Check before using',
        },
        body: {
          pt: 'Confirme a validade, as condições e se o código se aplica ao seu pedido. Ofertas podem mudar rapidamente, então verifique sempre as informações mais recentes.',
          de: 'Bestätigen Sie Gültigkeit, Bedingungen und ob der Code auf Ihre Bestellung anwendbar ist. Angebote ändern sich schnell, prüfen Sie daher immer die aktuellsten Informationen.',
          en: 'Confirm validity, conditions and whether the code applies to your order. Offers can change quickly, so always check the latest information.',
        },
      },
      {
        heading: {
          pt: 'Evite ofertas falsas',
          de: 'Falsche Angebote vermeiden',
          en: 'Avoid fake offers',
        },
        body: {
          pt: 'Desconfie de códigos de fontes não confiáveis. Nunca compartilhe sua senha ou dados de pagamento em troca de descontos. Prefira canais oficiais.',
          de: 'Seien Sie skeptisch bei Codes aus unzuverlässigen Quellen. Geben Sie niemals Passwort oder Zahlungsdaten im Tausch gegen Rabatte preis. Bevorzugen Sie offizielle Kanäle.',
          en: 'Be wary of codes from unreliable sources. Never share your password or payment details in exchange for discounts. Prefer official channels.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-warehouse',
    icon: 'ri-building-2-line',
    title: {
      pt: 'CSSBuy Warehouse Guide: Armazém, Armazenamento e Pedidos',
      de: 'CSSBuy Warehouse Guide: Lager, Speicherung und Bestellungen',
      en: 'CSSBuy Warehouse Guide: Storage, QC and Orders',
    },
    excerpt: {
      pt: 'Entenda como funciona o armazém do CSSBuy, o papel do armazenamento e como os pedidos são preparados para envio.',
      de: 'Verstehen Sie, wie das CSSBuy-Lager funktioniert, welche Rolle die Speicherung spielt und wie Bestellungen für den Versand vorbereitet werden.',
      en: 'Understand how the CSSBuy warehouse works, the role of storage and how orders are prepared for shipping.',
    },
    sections: [
      {
        heading: {
          pt: 'O papel do armazém',
          de: 'Die Rolle des Lagers',
          en: 'The role of the warehouse',
        },
        body: {
          pt: 'O armazém recebe os produtos comprados pelo agente, armazena temporariamente e consolida vários itens em um único envio, o que pode reduzir custos.',
          de: 'Das Lager empfängt die vom Agenten gekauften Produkte, speichert sie vorübergehend und bündelt mehrere Artikel in einem Versand, was Kosten senken kann.',
          en: 'The warehouse receives products purchased by the agent, stores them temporarily and consolidates multiple items into a single shipment, which can reduce costs.',
        },
      },
      {
        heading: {
          pt: 'Armazenamento e prazos',
          de: 'Speicherung und Fristen',
          en: 'Storage and timelines',
        },
        body: {
          pt: 'Há um período de armazenamento gratuito que pode variar. Após esse período, taxas podem ser aplicadas. Confirme os prazos atuais antes de acumular itens.',
          de: 'Es gibt eine kostenlose Speicherfrist, die variieren kann. Danach können Gebühren anfallen. Bestätigen Sie die aktuellen Fristen, bevor Sie Artikel ansammeln.',
          en: 'There is a free storage period that may vary. After that, fees may apply. Confirm current timelines before accumulating items.',
        },
      },
      {
        heading: {
          pt: 'Preparação para envio',
          de: 'Vorbereitung für den Versand',
          en: 'Preparing for shipment',
        },
        body: {
          pt: 'Antes do envio, os itens podem passar por verificação e embalagem. Consolidar pedidos e revisar fotos de QC ajuda a garantir que tudo esteja correto.',
          de: 'Vor dem Versand können Artikel geprüft und verpackt werden. Das Bündeln von Bestellungen und die Prüfung von QC-Fotos helfen sicherzustellen, dass alles korrekt ist.',
          en: 'Before shipping, items may undergo verification and packaging. Consolidating orders and reviewing QC photos helps ensure everything is correct.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-qc-guide',
    icon: 'ri-camera-line',
    title: {
      pt: 'CSSBuy QC Guide: Como Ler Fotos de Quality Control',
      de: 'CSSBuy QC Guide: So lesen Sie Quality-Control-Fotos',
      en: 'CSSBuy QC Guide: How to Read QC Photos',
    },
    excerpt: {
      pt: 'Aprenda a interpretar fotos de QC do CSSBuy para verificar qualidade, cor, tamanho e acabamento antes do envio.',
      de: 'Lernen Sie, CSSBuy-QC-Fotos zu interpretieren, um Qualität, Farbe, Größe und Verarbeitung vor dem Versand zu prüfen.',
      en: 'Learn to interpret CSSBuy QC photos to check quality, color, size and finish before shipping.',
    },
    sections: [
      {
        heading: {
          pt: 'O que são fotos de QC',
          de: 'Was sind QC-Fotos',
          en: 'What are QC photos',
        },
        body: {
          pt: 'QC (Quality Control) são fotos tiradas pelo agente antes do envio, mostrando o produto real. Elas permitem identificar defeitos ou diferenças em relação ao anúncio.',
          de: 'QC (Quality Control) sind Fotos, die der Agent vor dem Versand aufnimmt und die das echte Produkt zeigen. Sie helfen, Mängel oder Abweichungen von der Anzeige zu erkennen.',
          en: 'QC (Quality Control) are photos taken by the agent before shipping, showing the real product. They help identify defects or differences from the listing.',
        },
      },
      {
        heading: {
          pt: 'Como analisar as fotos',
          de: 'So analysieren Sie die Fotos',
          en: 'How to analyze the photos',
        },
        body: {
          pt: 'Compare as fotos de QC com as imagens do vendedor, prestando atenção a costura, logotipo, cor e tamanho. Peça fotos extras de áreas específicas quando necessário.',
          de: 'Vergleichen Sie QC-Fotos mit den Verkäuferbildern und achten Sie auf Nähte, Logo, Farbe und Größe. Fordern Sie bei Bedarf zusätzliche Fotos bestimmter Bereiche an.',
          en: 'Compare QC photos with seller images, paying attention to stitching, logo, color and size. Request extra photos of specific areas when needed.',
        },
      },
      {
        heading: {
          pt: 'Quando o QC é essencial',
          de: 'Wann QC wichtig ist',
          en: 'When QC is essential',
        },
        body: {
          pt: 'Para itens de marca, tênis e roupas, o QC é fundamental. Peça fotos de QC sempre que o detalhe e a autenticidade forem importantes para sua decisão.',
          de: 'Bei Markenartikeln, Schuhen und Kleidung ist QC entscheidend. Fordern Sie QC-Fotos immer dann an, wenn Detail und Authentizität für Ihre Entscheidung wichtig sind.',
          en: 'For branded items, shoes and clothing, QC is essential. Request QC photos whenever detail and authenticity matter to your decision.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-w2c-spreadsheet',
    icon: 'ri-file-list-3-line',
    title: {
      pt: 'CSSBuy W2C Spreadsheet: Links de Produtos e Achados',
      de: 'CSSBuy W2C Spreadsheet: Produktlinks und Fundstücke',
      en: 'CSSBuy W2C Spreadsheet: Product Links and Finds',
    },
    excerpt: {
      pt: 'Descubra como o CSSBuy W2C Spreadsheet organiza links de produtos, achados e referências para facilitar sua pesquisa.',
      de: 'Entdecken Sie, wie das CSSBuy W2C Spreadsheet Produktlinks, Fundstücke und Referenzen organisiert, um Ihre Recherche zu erleichtern.',
      en: 'Discover how the CSSBuy W2C Spreadsheet organizes product links, finds and references to make your research easier.',
    },
    sections: [
      {
        heading: {
          pt: 'O que significa W2C',
          de: 'Was W2C bedeutet',
          en: 'What W2C means',
        },
        body: {
          pt: 'W2C significa "where to cop", ou seja, onde encontrar um produto específico. O spreadsheet reúne esses links para facilitar a localização de itens desejados.',
          de: 'W2C bedeutet "where to cop", also wo man ein bestimmtes Produkt findet. Das Spreadsheet bündelt diese Links, um das Auffinden gewünschter Artikel zu erleichtern.',
          en: 'W2C means "where to cop", or where to find a specific product. The spreadsheet gathers these links to make locating desired items easier.',
        },
      },
      {
        heading: {
          pt: 'Como os links são organizados',
          de: 'Wie Links organisiert werden',
          en: 'How links are organized',
        },
        body: {
          pt: 'Os links são agrupados por categoria, tipo de produto e popularidade. Isso permite navegar de forma estruturada em vez de pesquisar manualmente em vários lugares.',
          de: 'Links werden nach Kategorie, Produkttyp und Beliebtheit gruppiert. Das ermöglicht strukturiertes Navigieren statt manueller Suche an mehreren Orten.',
          en: 'Links are grouped by category, product type and popularity. This allows structured navigation instead of manually searching in multiple places.',
        },
      },
      {
        heading: {
          pt: 'Use com responsabilidade',
          de: 'Verantwortungsvoll nutzen',
          en: 'Use responsibly',
        },
        body: {
          pt: 'O spreadsheet organiza informações, mas não garante qualidade ou autenticidade. Sempre verifique o produto e use QC antes de comprar.',
          de: 'Das Spreadsheet organisiert Informationen, garantiert aber keine Qualität oder Authentizität. Prüfen Sie immer das Produkt und nutzen Sie QC vor dem Kauf.',
          en: 'The spreadsheet organizes information but does not guarantee quality or authenticity. Always verify the product and use QC before purchasing.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-safety-guide',
    icon: 'ri-shield-check-line',
    title: {
      pt: 'CSSBuy Safety Guide: Compre com Mais Informação e Cuidado',
      de: 'CSSBuy Safety Guide: Sicherer und informierter einkaufen',
      en: 'CSSBuy Safety Guide: Shop with More Care',
    },
    excerpt: {
      pt: 'Dicas essenciais de segurança para usar o CSSBuy: verificar URLs, proteger a conta, evitar golpes e comprar com cuidado.',
      de: 'Wichtige Sicherheitstipps für CSSBuy: URLs prüfen, Konto schützen, Betrug vermeiden und vorsichtig einkaufen.',
      en: 'Essential safety tips for CSSBuy: verify URLs, protect your account, avoid scams and shop carefully.',
    },
    sections: [
      {
        heading: {
          pt: 'Segurança de URL e conta',
          de: 'URL- und Kontosicherheit',
          en: 'URL and account security',
        },
        body: {
          pt: 'Verifique sempre se você está no site correto e use uma senha forte e exclusiva. Nunca compartilhe sua senha com terceiros, mesmo que pareçam oficiais.',
          de: 'Prüfen Sie immer, ob Sie auf der richtigen Website sind, und verwenden Sie ein starkes, einzigartiges Passwort. Geben Sie Ihr Passwort niemals an Dritte weiter, selbst wenn diese offiziell wirken.',
          en: 'Always verify you are on the correct website and use a strong, unique password. Never share your password with third parties, even if they seem official.',
        },
      },
      {
        heading: {
          pt: 'Pagamentos seguros',
          de: 'Sichere Zahlungen',
          en: 'Safe payments',
        },
        body: {
          pt: 'Confirme os preços antes de pagar e desconfie de links suspeitos recebidos por mensagem. Prefira métodos de pagamento conhecidos e rastreáveis.',
          de: 'Bestätigen Sie Preise vor der Zahlung und seien Sie skeptisch bei verdächtigen Links aus Nachrichten. Bevorzugen Sie bekannte und nachvollziehbare Zahlungsmethoden.',
          en: 'Confirm prices before paying and be wary of suspicious links received via message. Prefer known, traceable payment methods.',
        },
      },
      {
        heading: {
          pt: 'Limites do spreadsheet',
          de: 'Grenzen des Spreadsheets',
          en: 'Spreadsheet limitations',
        },
        body: {
          pt: 'Este recurso é independente e não é garantia de qualidade, certificação oficial ou garantia de compra. Verifique sempre informações atualizadas nos canais oficiais.',
          de: 'Diese Ressource ist unabhängig und keine Qualitätsgarantie, offizielle Zertifizierung oder Kaufgarantie. Prüfen Sie aktuelle Informationen immer über offizielle Kanäle.',
          en: 'This resource is independent and is not a quality guarantee, official certification or purchase guarantee. Always verify updated information through official channels.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-beginner-guide',
    icon: 'ri-seedling-line',
    title: {
      pt: 'CSSBuy Beginner Guide: Começando do Zero',
      de: 'CSSBuy Beginner Guide: Von Null starten',
      en: 'CSSBuy Beginner Guide: Getting Started',
    },
    excerpt: {
      pt: 'Um guia passo a passo para iniciantes que querem entender o CSSBuy e fazer sua primeira compra com mais confiança.',
      de: 'Eine Schritt-für-Schritt-Anleitung für Einsteiger, die CSSBuy verstehen und ihren ersten Einkauf sicherer tätigen möchten.',
      en: 'A step-by-step guide for beginners who want to understand CSSBuy and make their first purchase with confidence.',
    },
    sections: [
      {
        heading: {
          pt: 'Entenda o fluxo básico',
          de: 'Den grundlegenden Ablauf verstehen',
          en: 'Understand the basic flow',
        },
        body: {
          pt: 'O fluxo básico é: encontrar o produto, enviar o link, o agente compra, recebe no armazém, tira fotos de QC e envia para você. Familiarizar-se com essas etapas reduz erros.',
          de: 'Der grundlegende Ablauf: Produkt finden, Link senden, der Agent kauft, lagert ein, macht QC-Fotos und versendet. Sich mit diesen Schritten vertraut zu machen, reduziert Fehler.',
          en: 'The basic flow is: find the product, submit the link, the agent buys it, receives it at the warehouse, takes QC photos and ships it. Familiarizing yourself with these steps reduces mistakes.',
        },
      },
      {
        heading: {
          pt: 'Dicas para a primeira compra',
          de: 'Tipps für den ersten Einkauf',
          en: 'Tips for your first purchase',
        },
        body: {
          pt: 'Comece com um item simples e de baixo valor para entender o processo. Verifique fotos de QC, confirme o custo total de envio e leia guias antes de comprar.',
          de: 'Beginnen Sie mit einem einfachen, preiswerten Artikel, um den Prozess zu verstehen. Prüfen Sie QC-Fotos, bestätigen Sie die Gesamtversandkosten und lesen Sie Guides vor dem Kauf.',
          en: 'Start with a simple, low-value item to understand the process. Check QC photos, confirm total shipping cost and read guides before purchasing.',
        },
      },
      {
        heading: {
          pt: 'Erros comuns a evitar',
          de: 'Häufige Fehler vermeiden',
          en: 'Common mistakes to avoid',
        },
        body: {
          pt: 'Evite não calcular o frete, ignorar o QC e confiar cegamente em links de terceiros. Pesquise sempre e confirme as informações antes de fechar o pedido.',
          de: 'Vermeiden Sie es, den Versand nicht zu kalkulieren, QC zu ignorieren und Links Dritter blind zu vertrauen. Recherchieren und bestätigen Sie Informationen immer vor der Bestellung.',
          en: 'Avoid not calculating shipping, ignoring QC and blindly trusting third-party links. Always research and confirm information before completing your order.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-seller-guide',
    icon: 'ri-store-2-line',
    title: {
      pt: 'CSSBuy Seller Guide: Pesquisa de Vendedores e Produtos',
      de: 'CSSBuy Seller Guide: Verkäufer- und Produktrecherche',
      en: 'CSSBuy Seller Guide: Product and Seller Research',
    },
    excerpt: {
      pt: 'Aprenda a pesquisar vendedores e produtos no CSSBuy, avaliar a confiabilidade e tomar decisões de compra mais informadas.',
      de: 'Lernen Sie, Verkäufer und Produkte bei CSSBuy zu recherchieren, Zuverlässigkeit zu bewerten und fundiertere Kaufentscheidungen zu treffen.',
      en: 'Learn to research sellers and products on CSSBuy, assess reliability and make more informed purchase decisions.',
    },
    sections: [
      {
        heading: {
          pt: 'Como pesquisar vendedores',
          de: 'So recherchieren Sie Verkäufer',
          en: 'How to research sellers',
        },
        body: {
          pt: 'Observe avaliações, histórico e reputação do vendedor. Compare preços e condições entre diferentes lojas antes de escolher onde comprar.',
          de: 'Achten Sie auf Bewertungen, Verlauf und Ruf des Verkäufers. Vergleichen Sie Preise und Bedingungen zwischen verschiedenen Shops, bevor Sie sich entscheiden.',
          en: 'Look at seller reviews, history and reputation. Compare prices and conditions across different stores before choosing where to buy.',
        },
      },
      {
        heading: {
          pt: 'Avaliando a confiabilidade',
          de: 'Zuverlässigkeit bewerten',
          en: 'Assessing reliability',
        },
        body: {
          pt: 'Sinais de confiabilidade incluem histórico consistente, boas avaliações e descrições claras. Desconfie de preços muito abaixo do mercado.',
          de: 'Anzeichen für Zuverlässigkeit sind konsistente Historie, gute Bewertungen und klare Beschreibungen. Seien Sie skeptisch bei Preisen weit unter Marktniveau.',
          en: 'Signs of reliability include consistent history, good reviews and clear descriptions. Be wary of prices far below market.',
        },
      },
      {
        heading: {
          pt: 'Pesquisa de produtos',
          de: 'Produktrecherche',
          en: 'Product research',
        },
        body: {
          pt: 'Use o spreadsheet para comparar produtos semelhantes, verificar fotos e entender o que esperar. Cruze informações de QC, preço e shipping antes de decidir.',
          de: 'Nutzen Sie das Spreadsheet, um ähnliche Produkte zu vergleichen, Fotos zu prüfen und Erwartungen zu verstehen. Kreuzen Sie QC-, Preis- und Versandinformationen vor der Entscheidung.',
          en: 'Use the spreadsheet to compare similar products, check photos and understand what to expect. Cross-reference QC, price and shipping information before deciding.',
        },
      },
    ],
  },
  {
    slug: 'cssbuy-alternatives',
    icon: 'ri-swap-line',
    title: {
      pt: 'CSSBuy Spreadsheet Alternatives: Comparação de Opções',
      de: 'CSSBuy Spreadsheet Alternatives: Optionen vergleichen',
      en: 'CSSBuy Spreadsheet Alternatives: Comparing Options',
    },
    excerpt: {
      pt: 'Compare o CSSBuy com outras alternativas de agente de compras e descubra qual opção se encaixa melhor nas suas necessidades.',
      de: 'Vergleichen Sie CSSBuy mit anderen Einkaufsagent-Alternativen und finden Sie heraus, welche Option am besten zu Ihnen passt.',
      en: 'Compare CSSBuy with other buying agent alternatives and find out which option fits your needs best.',
    },
    sections: [
      {
        heading: {
          pt: 'Principais alternativas',
          de: 'Wichtige Alternativen',
          en: 'Main alternatives',
        },
        body: {
          pt: 'Outras plataformas de agente de compras oferecem recursos semelhantes, como pesquisa de produtos, QC e armazém. Cada uma tem pontos fortes e fracos.',
          de: 'Andere Einkaufsagent-Plattformen bieten ähnliche Funktionen wie Produktrecherche, QC und Lager. Jede hat Stärken und Schwächen.',
          en: 'Other buying agent platforms offer similar features like product research, QC and warehouse. Each has strengths and weaknesses.',
        },
      },
      {
        heading: {
          pt: 'O que comparar',
          de: 'Was man vergleichen sollte',
          en: 'What to compare',
        },
        body: {
          pt: 'Compare custos de shipping, taxas, qualidade do QC, facilidade de uso e suporte. O que funciona para um comprador pode não ser ideal para outro.',
          de: 'Vergleichen Sie Versandkosten, Gebühren, QC-Qualität, Benutzerfreundlichkeit und Support. Was für einen Käufer funktioniert, ist für einen anderen nicht ideal.',
          en: 'Compare shipping costs, fees, QC quality, ease of use and support. What works for one buyer may not be ideal for another.',
        },
      },
      {
        heading: {
          pt: 'Como escolher',
          de: 'Wie man wählt',
          en: 'How to choose',
        },
        body: {
          pt: 'Defina suas prioridades: preço, velocidade ou segurança. Teste com compras pequenas e use o spreadsheet para organizar sua comparação.',
          de: 'Definieren Sie Ihre Prioritäten: Preis, Geschwindigkeit oder Sicherheit. Testen Sie mit kleinen Einkäufen und nutzen Sie das Spreadsheet zur Organisation Ihres Vergleichs.',
          en: 'Define your priorities: price, speed or safety. Test with small purchases and use the spreadsheet to organize your comparison.',
        },
      },
    ],
  },
];